var map = {
	"./icon-close.svg": "9e40",
	"./icon-lizard.svg": "82e7",
	"./icon-paper.svg": "5110",
	"./icon-rock.svg": "4c31",
	"./icon-scissors.svg": "7458",
	"./icon-spock.svg": "5a87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a23c";